export default __webpack_public_path__ + "static/media/safety.4b1b136e.jpg";